import React, { Component } from 'react';
import {Icon} from "@blueprintjs/core";
import {Map} from "immutable";

class SeriesTable extends Component {

    render() {
        return (this.props.series.size > 0
                ? (
                    <table className="table">
                        <thead>
                        <tr className="d-flex">
                            <th className="col-3 " style={{borderBottom: 'none'}}>Nombre</th>
                            <th className="col-2 " style={{borderBottom: 'none'}}>Prefijo</th>
                            <th className="col-2 " style={{borderBottom: 'none', textAlign: 'right', paddingRight: 30}}>Dígitos</th>
                            <th className="col-2 " style={{borderBottom: 'none', textAlign: 'right', paddingRight: 30}}>Último número</th>
                            <th className="col-2 " style={{borderBottom: 'none'}}>¿Serie por defecto?</th>
                            <th className="col-1 " style={{borderBottom: 'none'}}></th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.props.series.map(serie => {
                            return (
                                <tr className="d-flex" key={serie.get('_id')} >
                                    <td className="col-3">{serie.get('name')}</td>
                                    <td className="col-2">{serie.get('prefix')}</td>
                                    <td className="col-2" style={{ textAlign: 'right', paddingRight: 30 }} >{serie.get('number_length')}</td>
                                    <td className="col-2" style={{ textAlign: 'right', paddingRight: 30 }} >{serie.get('last_count')}</td>
                                    <td className="col-2" style={{paddingLeft: 65}}>
                                        {serie.get('is_default') ? <Icon icon="tick"/> : ''}
                                    </td>
                                    <td className="col-1 d-flex justify-content-center">
                                        <Icon
                                            className="cursor-pointer"
                                            icon="edit"
                                            onClick={() => this.props.openModal(
                                                'updateSerieDialog',
                                                Map({
                                                    docType: serie.get('document_type'),
                                                    serieId: serie.get('_id')
                                                })
                                            )}
                                        />
                                        <Icon
                                            className="cursor-pointer"
                                            icon="trash"
                                            style={{marginLeft: 7}}
                                            onClick={() => this.props.openModal(
                                                'deleteSerieDialog',
                                                Map({
                                                    docType: serie.get('document_type'),
                                                    serieId: serie.get('_id')
                                                })
                                            )}
                                        />
                                    </td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </table>
                ) : 'No hay ningúna numeración para este tipo de documento.'
        );
    }

}

export default SeriesTable;


// WEBPACK FOOTER //
// ./src/components/common/SeriesTable.js